var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTrendDown = function SvgIconTrendDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.957 6.043a1 1 0 0 0-1.414 1.414l6.75 6.75a1 1 0 0 0 1.414 0l3.043-3.043 6.586 6.586H15.75a1 1 0 1 0 0 2h6.003a.996.996 0 0 0 .996-.952l.001-.048v-6a1 1 0 1 0-2 0v3.586l-7.293-7.293a1 1 0 0 0-1.414 0L9 12.086z"
  })));
};
export default SvgIconTrendDown;